import { DateTime } from 'luxon';
import { IAssociatedAddressResponse } from './IAssociatedAddressResponse';
import { IAssociatedAddress } from './IAssociatedAddress';
import { convertAddressFromAPIToData } from '../../../../ui-toolkit/orders/methods/convertApiToData';

export const convertAssociatedAddressApiToData = ({
  file_number,
  external_status,
  transaction_category,
  address,
  created_at,
  ...rest
}: IAssociatedAddressResponse): IAssociatedAddress => ({
  ...rest,
  fileNumber: file_number,
  externalStatus: external_status,
  transactionCategory: transaction_category,
  address: convertAddressFromAPIToData(address),
  created: DateTime.fromISO(created_at).toJSDate(),
});

export interface IAssociatedAddressesResponse {
  addresses: IAssociatedAddressResponse[];
}
